import { parseQuery } from '@pascal/pascal-core';
import { configStore } from '../../module/config/configStore';
import { applicationStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { PlayingGameMode } from '../enums/PlayingGameMode';
import { RtlLanguages } from '../constants/rtlLanguages';
import { PascalGamingPartnerId } from '../constants/gameId';

export const setupConfig = () => {
  const query = parseQuery(window.location.search);
  const { playerexternalid, partnerid, lan, language, culture, opentype, mode, currencysymbol, realmodeswitcher } = query;

  if(currencysymbol){
    configStore.setPartnerCurrencySymbol(currencysymbol)
  }

  if (query.hasOwnProperty('partnerid')) {
    configStore.setPartnerId(partnerid);
  }

  if (query.hasOwnProperty('culture') || query.hasOwnProperty('language') || query.hasOwnProperty('lan')) {
    configStore.setLanguage(culture || lan || language);
  }

  if (playerexternalid) {
    userInfoStore.setPlayerExternalId(playerexternalid);
  }

  const demoValue = playerexternalid ? PlayingGameMode.Real : PlayingGameMode.Demo;

  configStore.setMode(demoValue);
  applicationStore.setIsDemo(demoValue === PlayingGameMode.Demo);

  if (
    (query.hasOwnProperty('opentype') && opentype === 'fun')
    ||
    (query.hasOwnProperty('mode') && mode === 'fun')
  ) {
    configStore.setMode(PlayingGameMode.Demo);
    applicationStore.setIsDemo(true);
  }else {
    userInfoStore.setCurrencySymbol(currencysymbol)
  }

  if (RtlLanguages.includes(configStore.language)) {
    document.documentElement.setAttribute('data-dir', 'rtl');
  }

  if (partnerid === PascalGamingPartnerId || realmodeswitcher) {
    configStore.setShowPlayForReal(false);
  }

};